import React, { useState } from "react";
import styled from "styled-components";
import { FiChevronUp, FiChevronDown } from "react-icons/fi";
const Summary = styled.div`
  box-shadow: 1px 1px 0px #efefef;
  background: white;
  padding: 10px;
  margin: 10px 0px;
  border-radius: 2px;
  border: 1px solid #eee;
  font-size: 12px;
  cursor: pointer;
  table {
    font-size: 12px;
    margin-top: 20px;
  }
`;
const toINR = (num) => {
  return "₹ " + parseInt(num).toLocaleString("en-IN");
};
const Val = styled.div`
  font-size: 14px;
  font-weight: 400;
`;
const Cat = styled.div`
  font-size: 12px;
  font-weight: 200;
`;
const SummaryWrapper = (props) => {
  const [expand, setExpand] = useState(false);
  const group = props.group;
  const date = new Date(group.end_date);
  return (
    <Summary>
      <div className="columns" onClick={() => setExpand(!expand)}>
        <div className="column col-4">
          <Val>
            {group.clean_transaction_note && group.clean_transaction_note != ""
              ? group.clean_transaction_note
              : group.transaction_channel}
          </Val>
          <Cat>{group.type == "credit" ? "Source" : "Destination"}</Cat>
        </div>
        <div className="column col-1">
          <Val>{toINR(group.median)}</Val> <Cat>Median</Cat>
        </div>
        <div className="column col-2">
          <Val>{date.toDateString()}</Val> <Cat>Last Date</Cat>
        </div>
        <div className="column col-2">
          <Val>{group.transactions.length}</Val>
          <Cat>Occurences</Cat>
        </div>
        <div className="column col-2">
          <Val>
            {group.type === "credit" ? (
              <span style={{ color: "green" }}>Credit</span>
            ) : (
              <span style={{ color: "red" }}>Debit</span>
            )}
          </Val>
          <Cat>Type</Cat>
        </div>
        <div
          className="column col-1"
          style={{ display: "flex", alignItems: "center" }}
        >
          {expand ? <FiChevronUp /> : <FiChevronDown />}
        </div>
      </div>
      {expand && (
        <table
          className="table table-striped"
          style={{ borderTop: "1px solid #bbb" }}
        >
          <thead>
            <tr>
              <th>Date</th>
              <th>Amount</th>
              <th>Balance</th>
              <th>Channel</th>
              <th>Transaction Note</th>
            </tr>
          </thead>
          <tbody>
            {group.transactions.map((row) => (
              <tr>
                <td>{row.date}</td>
                <td>{toINR(row.amount)}</td>
                <td>{toINR(row.balance)}</td>
                <td>{row.transaction_channel}</td>
                <td>{row.transaction_note}</td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </Summary>
  );
};
export default class Table extends React.Component {
  render() {
    return (
      <div>
        <table className="table">
          <tbody>
            {[
              ...this.props.data["credit_transactions"].map((v) => ({
                ...v,
                type: "credit",
              })),
              ...this.props.data["debit_transactions"].map((v) => ({
                ...v,
                type: "debit",
              })),
            ]
              .sort((a, b) => b.transactions.length - a.transactions.length)
              .map((group) => {
                return <SummaryWrapper group={group} />;
              })}
          </tbody>
        </table>
      </div>
    );
  }
}
